import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { ExportsPaginationTable } from 'backoffice/payments/_components';

const WithdrawExportsPage = () => (
  <ExportsPaginationTable captionSlug="listOfWithdrawalExports" exportsType="withdraw_export" />
);

export default compose(withRouter)(WithdrawExportsPage);
export { WithdrawExportsPage };
